import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import { getFormattedTime } from "utils"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"

const codesListColumns = actions => {
  let columns = [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, code) => <>{code.id}</>,
    },
    {
      text: "Role",
      dataField: "role",
      formatter: (cellContent, code) => <>{code?.role}</>,
    },
    {
      text: "Code",
      dataField: "code",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, code) => <>{code?.code}</>,
    },
    {
      text: "Type",
      dataField: "type",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, code) => (
        <>{code?.is_digital === 1 ? "Digital" : "Phisical"}</>
      ),
    },
    {
      text: "Name",
      dataField: "first_name",
      formatter: (cellContent, code) => (
        <>
          {!code?.first_name && !code?.first_name
            ? "-"
            : (code?.first_name ? code?.first_name : "") +
              " " +
              (code?.last_name ? code?.last_name : "")}
        </>
      ),
    },
    {
      text: "Email",
      dataField: "email",
      formatter: (cellContent, code) => (
        <>{code?.user_id ? code?.email : "-"}</>
      ),
    },
    {
      text: "Event",
      dataField: "event_name",
      formatter: (cellContent, code) => (
        <>{code?.event_id ? code?.event_name : "-"}</>
      ),
    },
    {
      text: "Date Redeemed",
      dataField: "updated_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, code) => (
        <>{getFormattedTime(code?.updated_at)}</>
      ),
    },
    {
      text: "Date Generated	",
      dataField: "created_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, code) => (
        <>{getFormattedTime(code?.created_at)}</>
      ),
    },
  ]
  if (actions && actions.length > 0) {
    columns.push({
      dataField: "menu",
      isDummyField: true,
      text: "",
      align: "right",
      formatter: (cellContent, col) => (
        <UncontrolledDropdown>
          <DropdownToggle href="#" className="card-drop" tag="i">
            <i className="mdi mdi-dots-vertical font-size-18" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            {actions.map((a, index) => (
              <DropdownItem
                key={index}
                href="#"
                onClick={e => {
                  e.preventDefault()
                  a.onClick(col)
                }}
                disabled={a?.checkIfDisabled(col) || false}
              >
                <i className={a.icon} /> {a.name}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </UncontrolledDropdown>
      ),
    })
  }
  return columns
}

export default codesListColumns
